import { render, staticRenderFns } from "./WeInMediaSection.vue?vue&type=template&id=2a72b110&scoped=true&"
import script from "./WeInMediaSection.vue?vue&type=script&lang=js&"
export * from "./WeInMediaSection.vue?vue&type=script&lang=js&"
import style0 from "./WeInMediaSection.vue?vue&type=style&index=0&id=2a72b110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72b110",
  null
  
)

export default component.exports